<template>
  <div class="w-full">
    <h2 class="text-lg font-bold mb-2">Order Summary</h2>
    <div class="space-y-2 pt-2">
      <!-- Header -->
      <LineItemHeader />
      
      <!-- Regular line items -->
      <template v-for="(item, index) in aggregateLineItems" :key="`lineitem-${index}`">
        <LineItem 
          v-if="item.itemType !== Constants.SERVICE_FEE" 
          class="font-medium"
          :description="item.name" 
          :quantity="getQuantity(item)"
          :amount="item.amount" 
        />
      </template>

      <!-- Service fee -->
      <LineItem v-if="serviceFee > 0"
        class="font-medium" 
        description="Stripe Processing Fee" 
        :amount="serviceFee" 
      />

      <!-- Sales tax -->
      <!-- <LineItem 
        class="font-medium"
        description="Sales tax" 
        :amount="salesTax" 
      /> -->

      <!-- Total -->
      <LineItem 
        class="border-t border-border-medium font-bold pt-2" 
        description="Total" 
        :amount="totalAmount" 
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue";
import { Item } from "@models/Item";
import LineItem from "./LineItem.vue";
import Constants from "@/models/Constants";
import LineItemHeader from "./LineItemHeader.vue";

interface Props {
  lineItems: Item[];
  totalAmount: number;
}

const props = defineProps<Props>();

const aggregateLineItems = computed<Item[]>(() => {
  return props.lineItems.reduce((prev, curr) => {
    const item = prev.find((x) => x.itemId === curr.itemId);
    if (item) {
      item.amount += curr.amount;
      item.quantity = (item.quantity || 0) + (curr.quantity || 1);
    } else {
      const updateItem = { ...curr };
      // Ensure quantity exists
      if (updateItem.quantity === undefined) {
        updateItem.quantity = 1;
      }
      prev.push(updateItem);
    }
    return prev;
  }, [] as Item[]);
});

// Update getQuantity to directly use the quantity from the aggregated item
const getQuantity = (item: Item) => {
  return item.quantity || 1;
};

const serviceFee = computed(() => {
  const item = aggregateLineItems.value.find(x => x.itemType === Constants.SERVICE_FEE);
  return item?.amount ?? 0;
});

</script>
